import SortBoxEndpoints from "../lib/sortbox/SortBoxEndpoints";

export const updateLockExpiration = (sortBoxID, delaySeconds = 300) => {
  return setTimeout(() => {
    extendSortBoxLockExpiration(sortBoxID);
    updateLockExpiration(sortBoxID, delaySeconds);
  }, delaySeconds * 1000);
};

export const extendSortBoxLockExpiration = (sortBoxID) => {
  SortBoxEndpoints.extendSortboxLockExpiration(sortBoxID)
    .then()
    .catch((e) => {
      console.log(e);
    });
};

export const clearUpdateLockExpiration = (updateLockExpirationTimeoutID) => {
  clearTimeout(updateLockExpirationTimeoutID);
};
